import { createFileRoute, Navigate } from '@tanstack/react-router';

import { launchRoute } from '@common/utils/startParam';

export const Route = createFileRoute('/')({
  component: () => <Navigate to={launchRoute()} />,
});
